<template>
  <el-cascader
    ref="cascader"
    style="width:100%;"
    v-model="selecteds"
    :clearable="clearable"
    :options="options"
    :props="vprops"
    :size="size"
    :disabled="disabled"
    @change="onChange"
    :placeholder="placeholder"
  ></el-cascader>
</template>
<script>
import { request } from '@/api/service'
import { mapState } from 'vuex'
export default {
  props: {
    placeholder: { type: String, default: () => '请选择' },
    props: { type: Object, default: () => {} },
    value: Array,
    lastValue: String,
    valueString: String,
    pathLabels: String,
    disabled: { type: Boolean, default: false },
    size: { type: String, default: 'small' },
    clearable: { type: Boolean, default: false },
  },
  data() {
    return {
      options: [],
      selecteds: this.value,
      vprops: {
        checkStrictly: true,
        ...this.props,
        multiple: false,
      },
    }
  },
  watch: {
    lastValue: {
      handler(val) {
        if (!this.value) {
          if (!val) return (this.selecteds = [])
          const { valuePath } = this.optionsMap[this.lastValue] || {}
          this.selecteds = JSON.parse(valuePath || '[]')
        }
      },
    },
  },
  computed: {
    ...mapState('admin/system', ['app']),
    optionsMap() {
      const options = this.options || []
      return this.toMap(options)
    },
  },
  async created() {
    const nodes = await this._dataTransform(await this.getData())
    this.options = nodes
    if (this.lastValue) {
      const { valuePath = null } = this.optionsMap[this.lastValue] || {}
      this.selecteds = JSON.parse(valuePath) || []
    }
  },
  methods: {
    toMap(options) {
      return options.reduce((r, n) => {
        r[n.value] = n
        if (n.children && n.children.length) {
          r = { ...r, ...this.toMap(n.children) }
        }
        return r
      }, {})
    },
    onChange(vals) {
      this.$emit('update:value', vals)
      this.$emit('update:valueString', JSON.stringify(vals))

      const checkedNodes = this.getCheckedNodes()
      if (!checkedNodes || !checkedNodes.length) {
        this.clearValue()
      }

      const checkedNode = checkedNodes[0] || {}
      let pathLabels = checkedNode.pathLabels || []
      this.$emit('update:lastValue', checkedNode.value)
      this.$emit('update:pathLabels', pathLabels.join('/'))
    },
    clearValue() {
      this.$emit('update:value', [])
      this.$emit('update:lastValue', '')
      this.$emit('update:valueString', '')
      this.$emit('update:pathLabels', '')
    },
    getCheckedNodes() {
      return this.$refs.cascader.getCheckedNodes()
    },
    async _dataTransform(nodes, parentValuePath) {
      if (!nodes || !nodes.length) return nodes
      return await Promise.all(nodes.map(async (node) => {
        const {
          fabricCategoryCode: value,
          fabricCategoryName: label,
          children,
        } = node

        const parentValuePaths = JSON.parse(parentValuePath || '[]')
        parentValuePaths.push(value)

        const valuePath = JSON.stringify(parentValuePaths)
        return {
          ...node,
          value,
          label,
          valuePath: valuePath,
          parentValuePath: parentValuePath,
          children: await this._dataTransform(children, valuePath),
        }
      }))
    },
    async getData(params = {}) {
      return this.getApi(params)
        .then((res) => res.body.data)
        .catch(() => [])
    },
    getApi(params) {
      return request({
        url: '/digitalCenter/masterFabricCategory/tree',
        method: 'post',
        params,
      })
    },
  },
}
</script>
